/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef } from 'react';
import { JudoPayCardForm } from './JudoPayCardForm';
import { OpayoCardForm } from './OpayoCardForm';
import { PomeloPayment } from './PomeloPayment';
export var CardForm = forwardRef(function (_a, ref) {
    var provider = _a.provider;
    if (provider.provider === 'judo' && provider.apiKey) {
        return jsx(JudoPayCardForm, { ref: ref, provider: provider });
    }
    else if (provider.provider === 'opayo') {
        return jsx(OpayoCardForm, { ref: ref, provider: provider });
    }
    else if (provider.provider === 'pomelo') {
        return jsx(PomeloPayment, { ref: ref });
    }
    else {
        return null;
    }
});
//# sourceMappingURL=CardForm.js.map